import React, { useState } from "react";

import Modal from '~/components/shared/modal'

import { aria_btn } from "~/styles/app.module.scss"
import * as mstyles from "~/styles/shared/modal.module.scss"
import * as styles from "~/styles/pdp/hem.module.scss"



const HemInfo = ({ onClose }) => {

  const [showing, setShowing] = useState('styling')
  

  return (
    <Modal name={'Hem'} childStyles={styles.modal} onModalClose={onClose}>
      
      <div className={mstyles.title} id="armodal_lab-hem">
        Inseam Alteration Guide
      </div>

      <div className={styles.details}>
        <button
          className={[aria_btn, styles.detail_btn].join(' ')}
          aria-expanded={showing === 'styling' ? 'true' : 'false'} 
          aria-controls="ar_detail-styling"
          onClick={(e)=> setShowing('styling')}
        >
          <span>Styling Instructions</span>
        </button>
        <div className={styles.copy} id="ar_detail-styling">
          <p>
            We now offer inseam alterations on select pants when you order online. We’ll hem your pants and deliver them ready to wear right out of the box.
          </p>
          <p>
            Inseam alterations allow you to get the perfect length for your height. We recommend aiming for a length that hits right at the center of your ankle, ensuring your pants won’t drag or pool over your shoes, but aren’t overly cropped. The goal is to create a clean line down your pant leg without showing any ankle while standing straight.
          </p>
          <p>
            Altered items cannot be returned or exchanged. All altered items are considered final sale.
          </p>

          <img className={styles.img} src="https://cdn.shopify.com/s/files/1/0123/5065/2473/files/StylingInstructions_Img-DK_900x.jpg?v=1689096074" alt="On body view of Buck Mason denim"/>
        </div>

        <button
          className={[aria_btn, styles.detail_btn].join(' ')}
          aria-expanded={showing === 'how' ? 'true' : 'false'} 
          aria-controls="ar_detail-how"
          onClick={(e)=> setShowing('how')}
        >
          <span>How to Measure</span>
        </button>
        <div className={styles.copy} id="ar_detail-how">
          <p>
            Start with a pair of pants that fits well and has the desired length. If you don’t have a pair in the right length, you can wear pants with a slightly longer inseam and cuff your pants to the desired length. Once you have it, lay the pants on a flat surface.
          </p>
          <p>
            From there, you’ll want to smooth and flatten the pants out so there are no creases in the legs. Take measuring tape and, starting from the bottom of the center seam where the two pant legs meet, draw the tape straight along the inner seam until it reaches the hem of the pant leg. This measurement is your inseam length.
          </p>
          <p>
            Altered items cannot be returned or exchanged. All altered items are considered final sale.
          </p>
          <img className={styles.img} src="https://cdn.shopify.com/s/files/1/0123/5065/2473/files/Inseam_DK_900x.jpg?v=1689096073" alt="How to measure the inseam of pants"/>
        </div>
      </div>

    </Modal> 
  )
};

export default HemInfo




